import React from 'react';
import styled from 'styled-components';
import { AnimatePresence, AnimatePresenceProps } from 'framer-motion';
import { ToastComponent, Toast } from './Toast';

interface ToastContainerProps {
  toasts: Toast[];
  onDismiss: (id: string) => void;
}

const Container = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
  
  @media (max-width: 768px) {
    top: 10px;
    right: 10px;
    left: 10px;
    
    > * {
      max-width: 100% !important;
    }
  }
`;

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onDismiss }) => {
  const AnimatePresenceComponent = AnimatePresence as any;
  return (
    <Container>
      <AnimatePresenceComponent initial={false}>
        {toasts.map((toast) => (
          <div key={toast.id} style={{ pointerEvents: 'auto' }}>
            <ToastComponent toast={toast} onDismiss={onDismiss} />
          </div>
        ))}
      </AnimatePresenceComponent>
    </Container>
  );
};

